<template>
    <div class="custom-fileInput" :class="status == false ? '': status" @drop="drop" @dragenter="dragEnter" :style="{cursor: type == 'image' || files.length < maxFiles ? 'pointer' : 'inherit'}">
        <input @change="changeFileInput" class="custom-fileInput-input" type="file" :accept="types.map(x => '.' + x).join(',')" :multiple="type == 'file'" hidden>
        <div v-if="!imageSrc" class="custom-fileInput-placeholder" v-html="text"></div>
        <transition name="customFileinputImage">
            <div class="custom-fileInput-image-preview" v-if="type == 'image' && imageSrc">
                <img :src="imageSrc" :class="imageSize == 'auto' ? 'custom-fileInput-size-auto' : ''">
                <div @click="clearFile(false)" class="custom-fileInput-image-preview-clear"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 16" width="12px" height="12px"><path d="M 4.1113281 1.2832031 L 1.2832031 4.1113281 L 5.171875 8 L 1.2832031 11.888672 L 4.1113281 14.716797 L 8 10.828125 L 11.888672 14.716797 L 14.716797 11.888672 L 10.828125 8 L 14.716797 4.1113281 L 11.888672 1.2832031 L 8 5.171875 L 4.1113281 1.2832031 z"/></svg></div>
            </div>
        </transition>
        <div class="custom-fileInput-filelist" v-if="type == 'file'">
            <transition-group name="customFileinputFile">
                <div v-for="item in files" :key="item.id" class="custom-fileInput-filelist-file" :class="item.status !== 0 ? 'has-errors' : 'successed'" :style="{borderRadius : '10px'}">
                    <div class="custom-fileInput-filelist-file-errors">
                        <div v-if="item.status !== 0">{{ item.status == 1 ? 'حجم فایل غیر مجاز است' : 'فرمت فایل مجاز نمی باشد'}}</div>
                    </div>
                    <div class="custom-fileInput-filelist-file-info">
                        <div>
                            <div class="custom-fileInput-filelist-file-info-name">{{ item.file.name }}</div>
                            <div class="custom-fileInput-filelist-file-info-size">{{ humanFileSize(item.file.size) }}</div>
                        </div>
                        <div @click="clearFile(item)" class="custom-fileInput-filelist-file-info-clear"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="14px" height="14px"><path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"/></svg></div>
                    </div>
                </div>
            </transition-group>
        </div>
        <div class="custom-fileInput-dragOverlay" v-if="showDragOverlay && (type == 'image' || files.length < maxFiles)">
            <div class="custom-fileInput-dragOverlay-inner" :style="{left: `${layerX}px`, top: `${layerY}px`}"></div>
        </div>
        <div @click="triggerInput" @dragover="dragOver" @dragleave="dragleave" class="custom-fileInput-overlay"></div>
    </div>
</template>
<script>
export default {
    props:{
        size:{
            type: Number,
            default: 512000
        },
        types:{
            type: Array,
            default: () => {return ['jpg', 'png', 'jpeg']}
        },
        mimeTypes:{
            type: Array,
            default: () => {return ['image/jpg', 'image/png', 'image/jpeg']}
        },
        text:{
            type: String,
            default: '<span>آپلود تصویر</span>'
        },
        type: {
            type: String,
            default: 'image' // file, image
        },
        maxFiles: {
            type: Number,
            default: 5
        },
        imageSize: {
            type: String,
            default: 'fill' // fill, auto
        }
    },
    data() {
        return {
            // style
            files: [],
            imageSrc: false,
            status: false,
            // drag & drop
            layerX: 0,
            layerY: 0,
            showDragOverlay: false
        }
    },
    methods: {
        humanFileSize(size) {
            var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
        },
        clearFile(file) {
            if(this.type == 'image') {
                file = this.files.length ? this.files[0] : false;
                this.status = false;
                this.imageSrc = false;
            }
            if(file)
                this.removeFiles(file)
            this.$emit('updated');
        },
        validate(file) {
            if(file.size > this.size)
                return 1;
            if(this.mimeTypes.length && !this.mimeTypes.includes(file.type))
                return 2;
            return 0;
        },
        addFiles(files) {
            if(!Array.isArray(files))
                files = [files];
            files.forEach(el => {
                let status = this.validate(el);
                if(this.type == 'image') {
                    this.imageSrc = status != 2 ? URL.createObjectURL(el) : false;
                    this.status = status == 0 ? 'successed' : 'has-errors';
                    if(this.files.length)
                        this.removeFiles(this.files[0]);
                }
                if(this.type == 'image' || this.files.length < this.maxFiles)
                    this.files.push({
                        id: (Math.random() + 1).toString(36).substring(7),
                        file: el,
                        status: status,
                    });
            });
            this.$emit('updated');
        },
        removeFiles(files) {
            if(!Array.isArray(files))
                files = [files];
            this.files = this.files.filter(x => files.findIndex(y => y?.id == x.id) == -1);
        },
        removeAllFiles() {
            this.files = [];
        },
        changeFileInput(e){
            if(e.target.files.length) {
                this.addFiles(Array.from(e.target.files))
                e.target.value = null;
            }
        },
        triggerInput(e) {
            if(this.type == 'image' || this.files.length < this.maxFiles)
                e.target.parentNode.querySelector('input').click();
        },
        setImageFileFromServer(src){
            this.imageSrc = src ?? false;
        },
        getFiles() {
            return this.type == 'file' ? this.files : (this.files.length ? this.files[0] : null);
        },
        getValidFiles() {
            return this.type == 'file' ? this.files.filter(x => x.status === 0) : (this.files.length && this.files[0].status === 0 ? this.files[0] : null);
        },
        drop(e){
            e.preventDefault();
            e.stopPropagation();
            this.showDragOverlay = false;
            if(e.dataTransfer.files.length)
                this.addFiles(Array.from(e.dataTransfer.files));
        },
        dragEnter(e){
            e.stopPropagation();
            e.preventDefault();
            if(e.target.classList.contains('custom-fileInput-overlay')){
                this.layerX = e.layerX;
                this.layerY = e.layerY;
                this.showDragOverlay = true;
            }
        },
        dragOver(e){
            e.stopPropagation();
            e.preventDefault();
            if(e.target.classList.contains('custom-fileInput-overlay')){
                setTimeout(() => {
                    this.layerX = e.layerX;
                    this.layerY = e.layerY;
                }, 75);
                this.showDragOverlay = true;
            }
        },
        dragleave(e){
            e.stopPropagation();
            e.preventDefault();
            if(e.target.classList.contains('custom-fileInput-overlay'))
                this.showDragOverlay = false;
        },
        paste(e) {
            e.preventDefault();
            e.stopPropagation();
            if(e.clipboardData.files)
                this.addFiles(Array.from(e.clipboardData.files));
        },
        activePasteEvent() {
            window.addEventListener('paste', this.paste);
        },
        deactivePasteEvent() {
            window.removeEventListener('paste', this.paste);
        }
    },
}
</script>
<style lang="scss" scoped>
    @keyframes customFileinputEnterImage {
        0% { opacity: 0; }
        100% { opacity: 1; }
    }
    @keyframes customFileinputLeaveImage {
        0% { opacity: 1; }
        100% { opacity: 0; }
    }
    @keyframes customFileinputEnterFile {
        0% { transform: translateX(-50px); opacity: 0; }
        100% { transform: translateX(0); opacity: 1;}
    }
    @keyframes customFileinputLeaveFile {
        0% { transform: translateX(0); opacity: 1; }
        100% { transform: translateX(50px); opacity: 0;}
    }
    .customFileinputImage-enter-active {
        animation: customFileinputEnterImage 0.8s;
    }
    .customFileinputImage-leave-active {
        animation: customFileinputLeaveImage 0.8s;
    }
    .customFileinputFile-enter-active {
        animation: customFileinputEnterFile 0.5s;
    }
    .customFileinputFile-leave-active {
        animation: customFileinputLeaveFile 0.5s;
    }
    .custom-fileInput{
        line-height: 1.5rem !important;
        position: relative;
        width: 100%;
        height: 100%;
        font-weight: 500;
        &-filelist{
            padding: 0 15px 5px;
            margin-top: -10px;
            &-file {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 100%;
                position: relative;
                z-index: 8;
                padding: 3px 10px;
                background-color: #616161;
                color: #ffffff;
                margin: 10px 0;
                &.successed {
                    background-color: #369763;
                }
                &.has-errors {
                    background-color: #c44e47;
                }
                &-info {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    text-align: end;
                    &-clear {
                        svg {
                            fill: white;
                        }
                        background-color: #2121219e;
                        border: 1px solid #2121219e;
                        cursor: pointer;
                        margin-right: 10px;
                        height: 28px;
                        width: 28px;
                        box-shadow: 0 0 10px #00000030;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: all ease-in-out 0.3s;
                        &:hover{
                            border-color: white;
                        }
                    }
                    &-name {
                        font-size: 0.75rem;
                    }
                    &-size {
                        font-size: 0.60rem;
                        color: #ececec;
                        direction: ltr;
                        text-align: start;
                        margin-top: -5px;
                    }
                }
                &-errors {
                    font-size: 0.75rem;
                }
            }
        }
        &.has-errors{
            box-shadow: 0 0 15px #bd0909 !important;
        }
        &.successed{
            box-shadow: 0 0 15px #00800083 !important;
        }
        &-overlay{
            position: absolute;
            inset: 0;
            z-index: 7;
        }
        &-dragOverlay{
            overflow: hidden;
            inset: 0;
            position: absolute;
            &-inner{
                position: absolute;
                transform: translate(-50%,-50%);
                background-color: rgba(0, 0, 0, 0.125);
                overflow: hidden;
                z-index: 6;
                width: 100px;
                height: 100px;
                border-radius: 50rem;
            }
        }
        &-image-preview{
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            inset: 0;
            border-radius: inherit;
            > img {
                border-radius: inherit;
                max-width: 100%;
                max-height: 100%;
                width: 100%;
                height: 100%;
                &.custom-fileInput-size-auto {
                    width: auto !important;
                    height: auto !important;
                }
            }
            &-clear{
                display: flex;
                background-color: #ffffffc4;
                cursor: pointer;
                height: 20px;
                width: 20px;
                box-shadow: 0 0 10px #00000030;
                border-radius: 50%;
                position: absolute;
                top: 3%;
                right: 3%;
                z-index: 8 !important;
                transition: all ease-in-out 0.3s;
                align-items: center;
                justify-content: center;
                &:hover{
                    background-color: #ffffffea;
                }
            }
        }
        &-placeholder{
            width: 100%;
            height: 100%;
        }
    }
</style>
